// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-u"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5L16 19H9C8.44772 19 8 18.5523 8 18L8 5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersUIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-u',
    ref,
    icon: element,
  },
));

LettersUIcon.displayName = 'LettersUIcon';

export default LettersUIcon;
